"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Container for rules used during price calculation.
 * Attributes of this class is a sub-set of {@link Settings} object.
 * We are interested in attributes that are kind of restrictions and not a target of these restrictions.
 * Several targets can have same rules.
 *
 * @author Jan Gregor
 */


var ReleasePriceCalculationRules =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleasePriceCalculationRules, _DomainObject_1$Domai);

  function ReleasePriceCalculationRules(competitorHistoryLength, competitorsPriorityId, constraintSettings, optimizationGoalsSettings, strategySettings) {
    var _this;

    _classCallCheck(this, ReleasePriceCalculationRules);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePriceCalculationRules).call(this));
    _this.competitorHistoryLength = competitorHistoryLength;
    _this.competitorsPriorityId = competitorsPriorityId;
    _this.constraintSettings = constraintSettings;
    _this.optimizationGoalsSettings = optimizationGoalsSettings;
    _this.strategySettings = strategySettings;
    return _this;
  }
  /**
   * Copies corresponding attributes from given {@link Settings} object.
   */


  _createClass(ReleasePriceCalculationRules, [{
    key: "fixCopy",

    /**
     * @inheritDoc
     */
    value: function fixCopy(copy) {
      var result = _get(_getPrototypeOf(ReleasePriceCalculationRules.prototype), "fixCopy", this).call(this, copy);

      result.stringified = null;
      return result;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (!other && Object.getPrototypeOf(this) !== Object.getPrototypeOf(other)) {
        return false;
      }

      return this.getStringified() === other.getStringified();
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      // Algorithm for string's hash-code copied from https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0
      var s = this.getStringified();
      return ObjectUtils_1.ObjectUtils.hashCode(s);
    }
  }, {
    key: "getStringified",
    value: function getStringified() {
      if (!this.stringified) {
        this.stringified = JSON.stringify(this);
      }

      return this.stringified;
    }
  }], [{
    key: "fromSettings",
    value: function fromSettings(settings) {
      return new ReleasePriceCalculationRules(settings.competitorHistoryLength, settings.competitorsPriorityId, settings.constraintSettings, settings.optimizationGoalsSettings, settings.strategySettings);
    }
  }]);

  return ReleasePriceCalculationRules;
}(DomainObject_1.DomainObject);

exports.ReleasePriceCalculationRules = ReleasePriceCalculationRules;
ReleasePriceCalculationRules.EMPTY = new ReleasePriceCalculationRules(null, null, null, null, null); // tslint:disable:max-classes-per-file

/**
 * Settings used during price calculations.
 * It's data will be in most cases marge of several {@link Settings} objects
 * (where the merge is represented on {@link Settings} object without ID).
 *
 * @author Jan Gregor
 */

var ReleasePriceCalculationSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(ReleasePriceCalculationSettings, _DomainObject_1$Domai2);

  function ReleasePriceCalculationSettings(priceZoneId, productCategoryId, productSensitivityId, rules) {
    var _this2;

    _classCallCheck(this, ReleasePriceCalculationSettings);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePriceCalculationSettings).call(this));
    _this2.priceZoneId = priceZoneId;
    _this2.productCategoryId = productCategoryId;
    _this2.productSensitivityId = productSensitivityId;
    _this2.rules = rules;
    return _this2;
  }
  /**
   * Copies corresponding attributes from given {@link Settings} object.
   */


  _createClass(ReleasePriceCalculationSettings, null, [{
    key: "fromSettings",
    value: function fromSettings(settings) {
      return new ReleasePriceCalculationSettings(settings.priceZoneId, settings.productCategoryId, settings.productSensitivityId, ReleasePriceCalculationRules.fromSettings(settings));
    }
  }]);

  return ReleasePriceCalculationSettings;
}(DomainObject_1.DomainObject);

exports.ReleasePriceCalculationSettings = ReleasePriceCalculationSettings;